<template>
  <div>
    <h2 class="title">Extract Status</h2>
    <h5 class="subtitle">This report is updated every 12-hours and will reset to zero after each monthly scan.</h5>
    <loading :loading="isLoading">
      <error :error="error"/>
      <div v-if="page">
        <b-form-group label="Report filters" style="margin: 50px 0">
          <b-form-select v-model="filters.onlyAuthority" :options="filters.allAuthorities" class="mb-3" />
          <b-form-checkbox-group v-model="filters.selected" name="flavour1" :options="filters.allOptions"/>
        </b-form-group>
        <small>{{ filteredComparison.length | commas }} of {{ page.Comparison.length | commas }} shown</small>
        <b-table v-if="filteredComparison" :items="filteredComparison">
          <template #cell(authority)="data">
            <div class="text-bold">
              {{ data.index === 0 || filteredComparison[data.index-1].authority !== data.value ? data.value : '' }}
            </div>
          </template>
          <template #head(last_counter)>
            <div class="text-right"># Records last month</div>
          </template>
          <template #cell(last_counter)="data">
            <div class="text-right">{{ data.value | commas }}</div>
          </template>
          <template #head(table_name)>Extract Type</template>
          <template #cell(table_name)="data">{{ data.value.replace(/_/g, ' ') }}</template>
          <template #head(current_counter)>
            <div class="text-right"># Records this month</div>
          </template>
          <template #cell(current_counter)="data">
            <div style="padding:5px;position:relative;" :class="`text-right ${calculatedCurrentCellClass(data.item)}`">
              <i style="position:absolute;left:9px;top:9px" :class="calculatedCurrentIcon(data.item)"></i>
              {{ data.value | commas }}
            </div>
          </template>
        </b-table>
      </div>
    </loading>
  </div>
</template>

<script>
import Loading from '@/components/Loading.vue'
import Error from '@/components/Error.vue'

export default {
  components: { Loading, Error }, 
  data() {
    return {
      isLoading: true,
      page: null,
      error: null,
      filters: {
        onlyAuthority: '',
        allAuthorities: [],
        selected: [],
        allOptions: [
          { value: 'hideMissing', text: 'Hide extracts missing from this month' }, 
          { value: 'hideSame', text: 'Hide extract same as last month' },
          { value: 'hidePresent', text: 'Hide extract already present this month' }
        ],
      },
    };
  },
  computed: {
    filteredComparison() {
      if (!this.page || !this.page.Comparison) {
        return [];
      }
      var items = [ ...this.page.Comparison ];
      if (this.filters.selected.indexOf('hideMissing') !== -1) {
        items = items.filter(r => r.current_counter > 0);
      }
      if (this.filters.selected.indexOf('hidePresent') !== -1) {
        items = items.filter(r => r.current_counter === 0);
      }
      if (this.filters.selected.indexOf('hideSame') !== -1) {
        items = items.filter(r => r.current_counter !== r.last_counter);
      }
      if ((this.filters.onlyAuthority || '') !== '') {
        items = items.filter(r => r.authority === this.filters.onlyAuthority);
      }
      return items;
    },
  },
  mounted() {
    this.isLoading = true;
    const { access_token } = this.$store.state.oidcStore;
    this.$reportingApi.renderPage('panessex', access_token, {
      pageName: 'SupportCompareToLastMonth',
    })
    .then((page) => {
      // prepare data and filter options from returned data
      const allAuthorities = { '': true };
      const items = page.Comparison.reduce((a, c) => {
        allAuthorities[c.authority] = true;
        a[c.category] = a[c.category] || { ...c, last_counter: 0, current_counter: 0 };
        a[c.category][`${c.table_name.indexOf('current') === 0 ? 'current' : 'last'}_counter`] = c.counter;
        delete a[c.category].counter;
        delete a[c.category].category;
        return a;
      }, {});
      // assign
      page.Comparison = Object.values(items);
      this.page = page;
      this.filters.allAuthorities = Object.keys(allAuthorities).map(a => a === '' ? { text: 'All Authorities', value: '' } : {text: a, value: a});
      this.isLoading = false;
    })
    .catch(e => { this.error = e.message; this.isLoading = false; });
  },
  methods: {
    calculatedCurrentCellClass(record) {
      if (record.current_counter === 0) {
        return 'bg-danger text-white';
      }
      if (record.current_counter === record.last_counter) {
        return 'bg-success text-white';
      }
      if (record.current_counter > record.last_counter) {
        return 'bg-primary text-white';
      }
      return 'bg-warning text-dark';
    },
    calculatedCurrentIcon(record) {
      if (record.current_counter === 0) {
        return 'fas fa-exclamation-triangle';
      }
      if (record.current_counter === record.last_counter) {
        return '';
      }
      if (record.current_counter > record.last_counter) {
        return 'fas fa-arrow-up';
      }
      return 'fas fa-arrow-down';
    },
  },
};
</script>
